<template>
  <div class="index">
    <!-- <Header ref="header" title="注册" :back="true" left="" /> -->
    <div class="windowmain">
      <div class="box_nav">
        <van-notice-bar
          wrapable
          :scrollable="false"
          style="background: #deebf7"
          :text="'掌上单一窗口仅可注册法人及其他组织的管理员账号。'"
        >
          <template slot="left-icon">
            <img
              style="width: 11px; margin-right: 4px;    margin-left: 4px;"
              src="@/views/image/userregister/icon_er.png"
              alt
              class="notice-bar-image"
            />
          </template>
        </van-notice-bar>
      </div>
      <div class="box_center">
        <p class="center_title">账号注册入口</p>
        <div class="center_tip" @click="funClick(1)">
             <img
             
              src="@/views/image/userregister/icon_or.png"
              alt
              class="center-image"
            />
            <p class="conter_p1">法人及其他组织用户</p>
            <p class="conter_p2">从事国际贸易进出口环节</p>
            <p class="conter_p3">各类业务的企业法人或其他组织</p>
        </div>
         <div class="center_tip" @click="funClick(2)">
             <img
              src="@/views/image/userregister/icon_user.png"
              alt
              class="center-image"
            />
            <p class="conter_p1">自然人用户</p>
            <p class="conter_p2">从事国际贸易进出口环节</p>
            <p class="conter_p3">各类业务的自然人用户</p>
        </div>
      </div>
      <div class="ftBton">
        <van-checkbox shape="square" v-model="acceptNotification"
          >已阅读并同意<span @click.stop="goXy(1)">《“掌上单一窗口”APP个人信息及用户隐私协议》</span>以及<span @click.stop="goXy(2)">《“掌上单一窗口”APP用户协议》</span></van-checkbox
        >
      </div>
      
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Toast,
  DatetimePicker,
  NoticeBar,
  Checkbox,
  CheckboxGroup,
  Dialog,
} from "vant";
const openWebBrowser = function() {
  let params = {
    url:
      'http://www.customs.gov.cn/eportal/ui?pageId=302266&currentPage=1&moduleld=08654b53d1cc42478813b0b2feddcb57'
  };
  this.native.openSystemWebview(params).then(res => {
    console.log(res);
  });
};
export default {
  name: "swuserregisterIndex",
  data() {
    return {
      statusBar: 0,
      dynamicTop: { top: "" },
      certName: "",
      userVerLink: "",
      priVerLink: "",
      acceptNotification: false,
      showOrginType: false,
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    // this.dynamicTop.top = this.$refs.header.$el.offsetHeight + "px";
    this.$http.get('/zsdyckserver/app/getAppVer').then(res => {
      this.userVerLink = 'https://update.singlewindow.cn/appDownload/zsdyck-userProtocol-' + res.retData.USERPRO_VER + '.html'
      this.priVerLink = 'https://update.singlewindow.cn/appDownload/zsdyck-privacyPolicy-' + res.retData.PRIVACY_VER + '.html'
      // this.$dialog.alert({
      //   message: JSON.stringify(res)
      // }).then(() => {
      // });
    })
  },

  methods: {
    openWebBrowser,
    funClick(val) {
      if (!this.acceptNotification) {
        //	window.location.href="http\x3A\x2F\x2Flocalhost\x3A8588\x2Fuserserver\x2Fuser/userEtpsRegister/MngRegister";
        // Dialog.alert({
        //   title: "提示",
        //   message: "请先勾选已阅读上述提示",
        //   messageAlign: "center",
        // });
        this.$toast('请先阅读并勾选协议')
        return;
      }
      if(val=="1"){
        window.location.href = '/userserver/user/userEtpsRegister/MngRegister';
        return;
        this.$router.push({
            path: '/swlegalperson',
          });
      }else{
         this.$router.push({
            path: '/swuserregister',
           
          });
      }
      
  //  window.location.href="http\x3A\x2F\x2Flocalhost\x3A8588\x2Fuserserver\x2Fuser/userEtpsRegister/MngRegister";
    
      // this.$router.zshgReplace({
      //   path: '/declare',
      // });
      // this.isBlock = false;
    },
    goXy(val){
      switch (val) {
        case 1:
          this.$router.push({
            path: '/agreementPri',
            query:{
              path:this.priVerLink
            }
          });
          break;
        case 2:
          this.$router.push({
            path: '/agreementUser',
             query:{
              path:this.userVerLink
            }
          });
          break;
      
        default:
          break;
      }
    }
  },

  components: {
    Header,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.name]: Dialog,
  },
};
</script>

<style scoped lang="scss">
@import "@/views/css/userindex.scss";
.index{
  height: calc(100% - 45px);
  background: #f7f8fa;
}
.windowmain {
  width: 100%;
  .box_nav {
    width: 100%;
    margin: 24px auto 10px;
  }
  .van-notice-bar {
    color: #1f4e79;
    font-size: 12px;
    padding: 0px 10px;
    font-weight: 400;
    border-top: 1px solid #c5dcf1;
    border-bottom: 1px solid #c5dcf1;
  }
  .box_center{
   
    margin: 15px 15px 0px 15px;
    height: auto;
  .center_title{
      font-size: 16px;
      font-weight: bold;
      color: #333;
  }
  .center_tip{
    width: 100%;
    text-align: center;
    background: #fff;
    border-radius: 4px;
    margin: 20px auto;
    padding-bottom: 15px;
    box-shadow: 0px 3px 2px 0px rgba(206,206,206,0.25);
  }
  .center-image{
    margin: 12px auto;
    width: 50px;
  }
  .conter_p1{
    font-size: 15px;
    color: #333;
       line-height: 20px;
       margin-bottom: 6px;
    cursor: pointer;
  }
  .conter_p2,.conter_p3{
    font-size: 12px;
      line-height: 18px;
    color: #999;
    cursor: pointer;
  }
  }
  .ftBton{
      padding: 0px 15px;
      font-size: 11px;
      color: #999;
      
  }
  ::v-deep .van-checkbox__icon{
    height: 0.9rem;

  }
  ::v-deep .van-checkbox__icon .van-icon{
    font-size: 11px;
  }
   ::v-deep .van-checkbox__label{
    color: #999;
    span{
      color: #096ac6;
    }
  }
}
</style>